import { Component, HostListener, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ThemeSelectors } from '@NgXs/Theme/theme.state';
import { Store } from '@ngxs/store';
import { Subject, takeUntil } from 'rxjs';
import { NgcCookieConsentService } from 'ngx-cookieconsent';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
  currentTheme: string;
  private unsubscribeAll: Subject<any> = new Subject<any>();

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent): void {
    if (event.ctrlKey && event.key === 'p') {
      event.preventDefault();
    }
  }

  constructor(
    private store: Store,
    private ccService: NgcCookieConsentService //this import is necessary in order to show the cookie consent popup. Dont remove it.
  ) {
    //dummy commit
  }

  ngOnInit() {
    this.store
      .select(ThemeSelectors.currentTheme)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe((theme) => {
        this.currentTheme = theme;
      });
  }

  ngOnDestroy(): void {
    this.unsubscribeAll.next(null);
    this.unsubscribeAll.complete();
  }
}
